import { memo } from "react"
import { useNavigate } from "@tanstack/react-router"

import { Button, Shortcut } from "@productlane/ui"

import type { AgentSetupItem } from "./agent-items"
import { useShortcut } from "@/lib"
import { useZeroWorkspace } from "@/lib/zero"
import { AgentMessage } from "./agent-message-header"
import { useAgentSetupDismissals } from "./agent-setup-dismissals"
import { DecisionBar } from "./decision-bar"
import { ButtonKeys, isTyping } from "./decline-button"

// Accept opens the settings page, where doing the step takes it off the list;
// Decline hides it for good.
export const SetupMessage = memo(
	({ item, onClosed }: { item: AgentSetupItem; onClosed: () => void }) => {
		const navigate = useNavigate()
		const workspace = useZeroWorkspace()
		const dismiss = useAgentSetupDismissals((state) => state.dismiss)
		const { step } = item
		const accept = () => void navigate({ to: step.path })
		const decline = () => {
			if (!workspace) return
			dismiss(workspace.id, step.id)
			onClosed()
		}
		useShortcut("2", decline, {
			enabled: !!workspace,
			ignoreEventWhen: isTyping,
		})
		useShortcut("1", accept, { ignoreEventWhen: isTyping })
		return (
			<div data-testid="agent-setup-message" className="px-1 pb-6">
				<AgentMessage at={0}>
					<p className="pt-1 text-sm leading-6 text-primary">{step.body}</p>
				</AgentMessage>
				<DecisionBar>
					<Button variant="ghost" onClick={decline}>
						Decline
						<Shortcut className="ml-1.5">2</Shortcut>
					</Button>
					<Button onClick={accept}>
						{step.action}
						<ButtonKeys>1</ButtonKeys>
					</Button>
				</DecisionBar>
			</div>
		)
	},
)
